import React from "react";

export default function ReviewStars({ average = 0, count = 0, compact = false, showCount = true }) {
  if (!count) return compact ? null : <span className="text-xs text-silver-dark">No reviews yet</span>;
  return (
    <span className={`inline-flex items-center gap-1 ${compact ? "text-[10px]" : "text-sm"}`} aria-label={`${average} out of 5 from ${count} reviews`}>
      <span className="tracking-tight text-amber-300" aria-hidden="true">★</span>
      <span className="font-medium text-silver-light">{Number(average).toFixed(1)}</span>
      {showCount && <span className="text-silver-dark">({count})</span>}
    </span>
  );
}
